import http from '../../utils/fetch';
export default {
    baseUrl:"/api/process/bscProProdef",
    page(query) {
        return http({
            url: this.baseUrl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    deletebyid(id){
        return http({
            url: this.baseUrl+'/deletebyid',
            method: 'post',
            params:{id:id}
        });
    },
    copeProdef(id){
        return http({
            url: this.baseUrl+'/copeProdef',
            method: 'post',
            params:{id:id}
        });
    },
    insertOrUpdate(f){
        return http({
            url: this.baseUrl+'/insertOrUpdate',
            method: 'post',
            data: f
        });
    },
    selectById(id){
        return http({
            url: this.baseUrl+'/selectById',
            method: 'post',
            params: {id}
        });
    },
    selectNodeLineById(p){
        return http({
            url: this.baseUrl+'/selectNodeLineById',
            method: 'post',
            params: p
        });
    },
    updateNode(f){
        return http({
            url: this.baseUrl+'/updateNode',
            method: 'post',
            data: f
        });
    },
    updateLine(f){
        return http({
            url: this.baseUrl+'/updateLine',
            method: 'post',
            data: f
        });
    }
}
